'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var cache = require('hashlru'); // @ts-ignore


var varint = require('varint');

var PeerId = require('peer-id');

var _require = require('interface-datastore/key'),
    Key = _require.Key;

var _require2 = require('p-queue'),
    Queue = _require2.default;

var c = require('./constants');

var utils = require('./utils');
/**
 * @typedef {import('multiformats/cid').CID} CID
 * @typedef {import('interface-datastore').Datastore} Datastore
 */

/**
 * This class manages known providers.
 * A provider is a peer that we know to have the content for a given CID.
 *
 * Every `cleanupInterval` providers are checked if they
 * are still valid, i.e. younger than the `provideValidity`.
 * If they are not, they are deleted.
 *
 * To ensure the list survives restarts of the daemon,
 * providers are stored in the datastore, but to ensure
 * access is fast there is an LRU cache in front of that.
 */


var Providers = /*#__PURE__*/function () {
  /**
   * @param {Datastore} datastore
   * @param {PeerId} [self]
   * @param {number} [cacheSize=256]
   */
  function Providers(datastore, self, cacheSize) {
    _classCallCheck(this, Providers);

    this.datastore = datastore;
    this._log = utils.logger(self, 'providers');
    /**
     * How often invalid records are cleaned. (in seconds)
     *
     * @type {number}
     */

    this.cleanupInterval = c.PROVIDERS_CLEANUP_INTERVAL;
    /**
     * How long is a provider valid for. (in seconds)
     *
     * @type {number}
     */

    this.provideValidity = c.PROVIDERS_VALIDITY;
    /**
     * LRU cache size
     *
     * @type {number}
     */

    this.lruCacheSize = cacheSize || c.PROVIDERS_LRU_CACHE_SIZE; // @ts-ignore hashlru types are wrong

    this.providers = cache(this.lruCacheSize);
    this.syncQueue = new Queue({
      concurrency: 1
    });
  }
  /**
   * Start the provider cleanup service
   */


  _createClass(Providers, [{
    key: "start",
    value: function start() {
      var _this = this;

      if (this._started) {
        return;
      }

      this._started = true;
      this._cleaner = setInterval(function () {
        return _this._cleanup();
      }, this.cleanupInterval);
    }
    /**
     * Release any resources.
     */

  }, {
    key: "stop",
    value: function stop() {
      this._started = false;

      if (this._cleaner) {
        clearInterval(this._cleaner);
        this._cleaner = null;
      }
    }
    /**
     * Check all providers if they are still valid, and if not delete them.
     *
     * @returns {Promise<void>}
     * @private
     */

  }, {
    key: "_cleanup",
    value: function _cleanup() {
      var _this2 = this;

      return this.syncQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var start, count, deleteCount, deleted, batch, query, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _parseProviderKey, cid, peerId, time, now, delta, expired, peers, _iterator3, _step3, _step3$value, _cid, _peers, key, provs, _iterator4, _step4, _peerId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2._log('start cleanup');

                start = Date.now();
                count = 0;
                deleteCount = 0;
                deleted = new Map();
                batch = _this2.datastore.batch(); // Get all provider entries from the datastore

                query = _this2.datastore.query({
                  prefix: c.PROVIDERS_KEY_PREFIX
                });
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 9;
                _iterator = _asyncIterator(query);

              case 11:
                _context.next = 13;
                return _iterator.next();

              case 13:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 19;
                  break;
                }

                entry = _step.value;

                try {
                  // Add a delete to the batch for each expired entry
                  _parseProviderKey = parseProviderKey(entry.key), cid = _parseProviderKey.cid, peerId = _parseProviderKey.peerId;
                  time = readTime(entry.value);
                  now = Date.now();
                  delta = now - time;
                  expired = delta > _this2.provideValidity;

                  _this2._log('comparing: %d - %d = %d > %d %s', now, time, delta, _this2.provideValidity, expired ? '(expired)' : '');

                  if (expired) {
                    deleteCount++;
                    batch.delete(entry.key);
                    peers = deleted.get(cid) || new Set();
                    peers.add(peerId);
                    deleted.set(cid, peers);
                  }

                  count++;
                } catch (err) {
                  _this2._log.error(err.message);
                }

              case 16:
                _iteratorAbruptCompletion = false;
                _context.next = 11;
                break;

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 25:
                _context.prev = 25;
                _context.prev = 26;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 30;
                  break;
                }

                _context.next = 30;
                return _iterator.return();

              case 30:
                _context.prev = 30;

                if (!_didIteratorError) {
                  _context.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context.finish(30);

              case 34:
                return _context.finish(25);

              case 35:
                _this2._log('deleting %d / %d entries', deleteCount, count); // Commit the deletes to the datastore


                if (!deleted.size) {
                  _context.next = 39;
                  break;
                }

                _context.next = 39;
                return batch.commit();

              case 39:
                // Clear expired entries from the cache
                _iterator3 = _createForOfIteratorHelper(deleted);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _step3$value = _slicedToArray(_step3.value, 2), _cid = _step3$value[0], _peers = _step3$value[1];
                    key = makeProviderKey(_cid);
                    provs = _this2.providers.get(key);

                    if (provs) {
                      _iterator4 = _createForOfIteratorHelper(_peers);

                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          _peerId = _step4.value;
                          provs.delete(_peerId);
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }

                      if (provs.size === 0) {
                        _this2.providers.remove(key);
                      } else {
                        _this2.providers.set(key, provs);
                      }
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                _this2._log('Cleanup successful (%dms)', Date.now() - start);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 21, 25, 35], [26,, 30, 34]]);
      })));
    }
    /**
     * Get the currently known provider peer ids for a given CID.
     *
     * @param {CID} cid
     * @returns {Promise<Map<string, Date>>}
     *
     * @private
     */

  }, {
    key: "_getProvidersMap",
    value: function () {
      var _getProvidersMap2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid) {
        var cacheKey, provs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cacheKey = makeProviderKey(cid);
                provs = this.providers.get(cacheKey);

                if (provs) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return loadProviders(this.datastore, cid);

              case 5:
                provs = _context2.sent;
                this.providers.set(cacheKey, provs);

              case 7:
                return _context2.abrupt("return", provs);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getProvidersMap(_x) {
        return _getProvidersMap2.apply(this, arguments);
      }

      return _getProvidersMap;
    }()
    /**
     * Add a new provider for the given CID.
     *
     * @param {CID} cid
     * @param {PeerId} provider
     * @returns {Promise<void>}
     */

  }, {
    key: "addProvider",
    value: function () {
      var _addProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid, provider) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.syncQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var provs, now, dsKey;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this3._log('addProvider %s', cid.toString());

                          _context3.next = 3;
                          return _this3._getProvidersMap(cid);

                        case 3:
                          provs = _context3.sent;

                          _this3._log('loaded %s provs', provs.size);

                          now = new Date();
                          provs.set(utils.encodeBase32(provider.id), now);
                          dsKey = makeProviderKey(cid);

                          _this3.providers.set(dsKey, provs);

                          return _context3.abrupt("return", writeProviderEntry(_this3.datastore, cid, provider, now));

                        case 10:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }))));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addProvider(_x2, _x3) {
        return _addProvider.apply(this, arguments);
      }

      return addProvider;
    }()
    /**
     * Get a list of providers for the given CID.
     *
     * @param {CID} cid
     * @returns {Promise<Array<PeerId>>}
     */

  }, {
    key: "getProviders",
    value: function () {
      var _getProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cid) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.syncQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var provs;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _this4._log('getProviders %s', cid.toString());

                          _context5.next = 3;
                          return _this4._getProvidersMap(cid);

                        case 3:
                          provs = _context5.sent;
                          return _context5.abrupt("return", _toConsumableArray(provs.keys()).map(function (base32PeerId) {
                            return new PeerId(utils.decodeBase32(base32PeerId));
                          }));

                        case 5:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getProviders(_x4) {
        return _getProviders.apply(this, arguments);
      }

      return getProviders;
    }()
  }]);

  return Providers;
}();
/**
 * Encode the given key its matching datastore key.
 *
 * @param {CID|string} cid - cid or base32 encoded string
 * @returns {string}
 *
 * @private
 */


function makeProviderKey(cid) {
  cid = typeof cid === 'string' ? cid : utils.encodeBase32(cid.bytes);
  return c.PROVIDERS_KEY_PREFIX + cid;
}
/**
 * Write a provider into the given store.
 *
 * @param {Datastore} store
 * @param {CID} cid
 * @param {PeerId} peer
 * @param {Date} time
 */


function writeProviderEntry(_x5, _x6, _x7, _x8) {
  return _writeProviderEntry.apply(this, arguments);
}
/**
 * Parse the CID and provider peer id from the key
 *
 * @param {import('interface-datastore/key').Key} key
 */


function _writeProviderEntry() {
  _writeProviderEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(store, cid, peer, time) {
    var dsKey, key, buffer;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            // eslint-disable-line require-await
            dsKey = [makeProviderKey(cid), '/', utils.encodeBase32(peer.id)].join('');
            key = new Key(dsKey);
            buffer = Uint8Array.from(varint.encode(time.getTime()));
            return _context7.abrupt("return", store.put(key, buffer));

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _writeProviderEntry.apply(this, arguments);
}

function parseProviderKey(key) {
  var parts = key.toString().split('/');

  if (parts.length !== 4) {
    throw new Error('incorrectly formatted provider entry key in datastore: ' + key);
  }

  return {
    cid: parts[2],
    peerId: parts[3]
  };
}
/**
 * Load providers for the given CID from the store.
 *
 * @param {Datastore} store
 * @param {CID} cid
 * @returns {Promise<Map<PeerId, Date>>}
 *
 * @private
 */


function loadProviders(_x9, _x10) {
  return _loadProviders.apply(this, arguments);
}
/**
 * @param {Uint8Array} buf
 */


function _loadProviders() {
  _loadProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(store, cid) {
    var providers, query, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entry, _parseProviderKey2, peerId;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            providers = new Map();
            query = store.query({
              prefix: makeProviderKey(cid)
            });
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context8.prev = 4;
            _iterator2 = _asyncIterator(query);

          case 6:
            _context8.next = 8;
            return _iterator2.next();

          case 8:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context8.sent).done)) {
              _context8.next = 15;
              break;
            }

            entry = _step2.value;
            _parseProviderKey2 = parseProviderKey(entry.key), peerId = _parseProviderKey2.peerId;
            providers.set(peerId, readTime(entry.value));

          case 12:
            _iteratorAbruptCompletion2 = false;
            _context8.next = 6;
            break;

          case 15:
            _context8.next = 21;
            break;

          case 17:
            _context8.prev = 17;
            _context8.t0 = _context8["catch"](4);
            _didIteratorError2 = true;
            _iteratorError2 = _context8.t0;

          case 21:
            _context8.prev = 21;
            _context8.prev = 22;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context8.next = 26;
              break;
            }

            _context8.next = 26;
            return _iterator2.return();

          case 26:
            _context8.prev = 26;

            if (!_didIteratorError2) {
              _context8.next = 29;
              break;
            }

            throw _iteratorError2;

          case 29:
            return _context8.finish(26);

          case 30:
            return _context8.finish(21);

          case 31:
            return _context8.abrupt("return", providers);

          case 32:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[4, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _loadProviders.apply(this, arguments);
}

function readTime(buf) {
  return varint.decode(buf);
}

module.exports = Providers;